export const LANDING_PAGE = ['Welcome to',
    'Skill Mantra',
    'Empowering careers through skills and opportunities',
    'Find Jobs',
    'Explore Courses',
    'What We Offer',
    'Expert-Led Courses',
    'Learn from industry professionals and enhance your skills',
    'Industry-relevant curriculum',
    'Self-paced learning',
    'Hands-on projects',
    'Explore Courses',
    'Career Opportunities',
    'Find the perfect job matching your skills and aspirations',
    'Personalized job matches',
    'Direct employer connect',
    'Career guidance',
    'Browse Jobs',
    'Start Your Career Journey Today',
    'Join Skill Mantra and take the first step towards your professional growth',
    'Get Started Now'
]

export const JOB_DETAILS = [
    'Back to Jobs',
    'Apply Now',
    'Successfully Applied!',
    'About the Job',
    'About the Company',   
]

export const JOB_LIST = [
    'Find Your Dream Job',
    'Discover opportunities that match your skills and aspirations',
    'Search jobs...',
    'Available Positions',
    'Explore our curated list of opportunities',
    'Explore Job Categories',
    'Find opportunities in your preferred domain',
    'Filter Jobs',
    'Apply',
    'Cancel',
    'Apply Filters',
    'Complete Your Profile',
    'Get personalized job recommendations based on your profile',
    'Complete Now',
    'Not Now'
]

export const MY_JOBS = [
    'My Jobs',
    'Refresh',
    'Update',
    'Cancel',
    'Accept Offer',
]

export const MY_OFF_NETWORK_JOBS = [
    'Back to Jobs',
    'You have already applied for this job. Please wait for the job provider to review your application.',
    'Apply',
    'About this role',
    'Key Details',
    'Positions',
    'Available',
    'Salary Range',
    'Work Schedule',
    'Monday to Saturday',
    'Location',
    'City',
    'Area',
    'Requirements',
    'Education',
    'Skills',
    'Required Documents',
    'Application Timeline',
    'From',
    'To'
]

export const USER_PROFILE = [
    'Logout',
    'Basic',
    'Credentials & Documents',
    'Additional Details',
    'Qualifications',
    'Job Preference',
    'Work Experience',
    'Edit Profile',
    'Cancel',
    'Save Changes'
]

export const PASSWORD_LOGIN = [
    'Email / Phone number',
    'Email / Phone number',
    'Email / Mobile number is required',
    'Invalid Email / Phone number format',
    'Enter Password',
    'Password',
    'Password is required',
    'Password must be at least 6 characters long',
    'Login'
]

export const OTP_LOGIN = [
    'Email / Phone number',
    'Email / Mobile number',
    'Email / Phone number is required',
    'Invalid Email / Phone number format',
    'OTP',
    'Enter OTP',
    'Send OTP',
    'Resend OTP in',
    'Verify OTP',
    'Resend OTP'
]

export const  LOGIN_CONTENT = [
    'Discover courses and job opportunities before Registering?',
    'Login using',
    'Signup',
    'Powered by'
]

export const SIGNUP_CONTENT = [
    'Discover courses and job opportunities before Registering?',
    'Mobile Number',
    'Mobile number is required.',
    'Mobile number must be 10 digits.',
    'Email',
    'Email is required.',
    'Invalid email format.',
    'Password',
    'Password is required.',
    'Password must be at least 6 characters long.',
    'Confirm Password',
    'Confirm password is required.',
    'Confirm password must be at least 6 characters long.',
    'Password Strength',
    'Uppercase Letter',
    'Lowercase Letter',
    'Number',
    'Special Character',
    'Minimum Length',
    'Passwords Match',
    'Sign Up',
    'Already have an account?',
    'Login',
    'Powered by'
]